// Generated by CoffeeScript 2.7.0
var DATE_RANGE, DAY_NUM_CN;

DATE_RANGE = {
  minute: 60,
  hour: 3600
};

DAY_NUM_CN = ['日', '一', '二', '三', '四', '五', '六'];

Date.parseFromString = function(str) {
  var _v, day, hour, minute, month, now, regex, year;
  if (_.isDate(str)) {
    return str._dup();
  }
  // ios 设备不能通过 new Date('YYYY-MM-DD hh:mm')解析时间(问题出在它不能解析时间，日期能解析)
  // 该方法只支持 YYYY-MM[-DD], hh:mm[:ss], YYYY-MM[-DD] hh:mm[:ss]这类格式
  regex = /((\d+)-(\d+)-(\d+))?(\s?(\d+):(\d+))?/;
  [_v, _v, year, month, day, _v, hour, minute] = _.map(str.match(regex), function(value) {
    if (value != null) {
      return Number(value);
    } else {
      return 0;
    }
  });
  now = new Date();
  return new Date(year || now.getFullYear(), (month || now.getMonth() + 1) - 1, day || now.getDate(), hour, minute);
};

Date.prototype._dup = function() {
  return new Date(this.valueOf());
};

Date.prototype.midnight = function() {
  var _date;
  _date = this._dup();
  _date.setHours(0, 0, 0, 0);
  return _date;
};

Date.prototype.endOfDay = function() {
  var _date;
  _date = this._dup();
  _date.setHours(23, 59, 59, 999);
  return _date;
};

// 返回回退year年，month月，days天的日期
Date.prototype.lastDays = function(year = 0, month = 0, days = 1) {
  var _date;
  _date = this._dup();
  // setYear是即将被废弃的方法，所以使用转换为月的方式处理
  _date.setMonth(this.getMonth() - (year * 12 + month), this.getDate() - days);
  return _date;
};

Date.prototype.yesterday = function(days = 1) {
  var _date;
  _date = this._dup();
  _date.setDate(this.getDate() - days);
  return _date;
};

Date.prototype.strftime = function(format = 'YYYY-MM-DD hh:mm:ss') {
  var day, hour, map, minute, month, second, year;
  year = this.getFullYear();
  month = this.getMonth() + 1;
  day = this.getDate();
  hour = this.getHours();
  minute = this.getMinutes();
  second = this.getSeconds();
  map = {
    YYYY: year,
    MM: ('0' + month).slice(-2),
    M: month,
    DD: ('0' + day).slice(-2),
    D: day,
    hh: ('0' + hour).slice(-2),
    h: hour,
    mm: ('0' + minute).slice(-2),
    m: minute,
    ss: ('0' + second).slice(-2),
    s: second
  };
  return format.replace(/Y+|M+|D+|h+|m+|s+/g, function(str) {
    return map[str];
  });
};

Date.prototype.toTimeAgoString = function() {
  var date, date_message, day, month, now, now_day, now_month, now_year, seconds, year;
  date = this.strftime('YYYY MM-DD');
  now = new Date();
  year = this.getFullYear();
  month = this.getMonth();
  day = this.getDate();
  now_year = now.getFullYear();
  now_month = now.getMonth();
  now_day = now.getDate();
  date_message = year === now_year && month === now_month ? day === now_day ? (seconds = (now - this) / 1000, seconds < DATE_RANGE.minute ? '刚刚' : seconds < DATE_RANGE.hour ? `${parseInt(seconds / DATE_RANGE.minute)}分钟之前` : `${parseInt(seconds / DATE_RANGE.hour)}小时之前`) : day + 1 === now_day ? '昨天' : day + 2 === now_day ? '2天前' : date : date;
  return `${date_message} 周${DAY_NUM_CN[this.getDay()]}`;
};

Object.defineProperty(Date.prototype, 'maxDateNumber', {
  get: function() {
    return new Date(this.getFullYear(), this.getMonth() + 1, 0).getDate();
  }
});
